import Logo from "./Logo";
import { HashLink } from 'react-router-hash-link';
import { useRef } from "react";

function Bar({ onEasterEgg }) {
  const clicks = useRef(0);
  const resetTimer = useRef(null);

  const handleLogoClick = () => {
    clicks.current += 1;
    window.clearTimeout(resetTimer.current);
    if (clicks.current === 3) {
      clicks.current = 0;
      onEasterEgg();
      return;
    }
    resetTimer.current = window.setTimeout(() => { clicks.current = 0; }, 650);
  };

  return (
    <header className="site-header">
      <nav className="bar" aria-label="Primary navigation">
        <HashLink className="brand" smooth to="#start" aria-label="Edward Xing, home" onClick={handleLogoClick}><Logo id="home-logo" path="home-logo-path"/><span>Edward Xing</span></HashLink>
        <div className="nav-links">
          <HashLink className="link" smooth to="#about">About</HashLink>
          <HashLink className="link" smooth to="#experience">Experience</HashLink>
          <HashLink className="link" smooth to="#projects">Work</HashLink>
          <HashLink className="link" smooth to="#contact">Contact</HashLink>
        </div>
      </nav>
    </header>
  );
}

export default Bar;
